import { View } from "../../../../../core/view/index";
import { FortumApp } from "../../../../fortumApp";


export abstract class ScannedItemView extends View {

    app: FortumApp;

    dataLoader: PromiseLike<any>;
    item: any;

    constructor(data) {
        super(data);
        this.constructItem(data);
    }

    protected constructItem(data)
    {
        // Start loading as soon as possible
        if (data.fetch_tag) {
            let splitted = null;
            let splitters = ['|', '\u001d'];
            splitters.some(splitter => {
                if (data.fetch_tag.indexOf(splitter) >= 0) {
                    splitted = data.fetch_tag.split(splitter, 2);
                }
                return splitted ? true : false;
            });

            if (splitted) {
                // Try to load local data first
                this.dataLoader = this.app.db.DeliveryNoteItem.get(parseInt(splitted[1])).then(item => {
                    if (item) {
                        console.debug('>>> Going with local data');
                        return item;
                    } else {
                        // Local data not available, go to network
                        return this.app.api.private('pt_delivery_note_item_info', {package_tag: data.fetch_tag});
                    }
                });
            } else {
                this.dataLoader = Promise.reject(new Error(this.pgettext('Error', 'Invalid package label')));
            }
            
        } else {
            this.dataLoader = Promise.resolve(data);
        }
    }

    public afterRender(): PromiseLike<any>
    {
        return this.dataLoader.then(
            data => this.onDataLoadedSuccessfully(data),
            error => this.onDataLoadError(error)
        );
    }

    protected abstract onDataLoadedSuccessfully(data);

    protected abstract onDataLoadError(error);

}